<template>
  <div class="draggable-container" @pointermove="updateMousePosition">
    <!-- <element-zoom
      :background-image="backgroundImage"
      :zoom-position="zoomPosition"
      :mouse-position="mousePosition"
      :mouse-position-polygon-point-offset="mousePositionPolygonPointOffset"
    /> -->
    <living-option-tags
      v-if="tags.length"
      v-model="tags"
    />
    <living-option-markers
      :property-ids="propertyIds ? propertyIds : []"
      :subsection-ids="subsectionIds ? subsectionIds : []"
      :subsection-group-ids="subsectionGroupIds ? subsectionGroupIds : []"
      :living-option-ids="livingOptionIds ? livingOptionIds : []"
    />
    <div
      class="draggable-container__bg"
      :class="{'no-image' : !backgroundImage }"
    >
      <img
        v-if="backgroundAssetType(backgroundImage) === 'image'"
        class="tag-bg"
        :class="{'hidden' : backgroundImage === ''}"
        :src="$store.state.assetsPath + backgroundImage"
      >
      <video
        v-if="backgroundAssetType(backgroundImage) === 'video'"
        class="tag-bg"
        :class="{'hidden' : backgroundImage === ''}"
        :src="$store.state.assetsPath + backgroundImage"
        autoplay
        muted
        loop
      ></video>
    </div>
  </div>
</template>

<script>
import ElementZoom from './ElementZoom.vue'
import LivingOptionTags from './LivingOptionTags.vue'
import LivingOptionMarkers from './LivingOptionMarkers.vue'

export default {
  props:['tags', 'propertyIds', 'subsectionIds', 'subsectionGroupIds', 'livingOptionIds', 'backgroundImage'],

  components: {
    ElementZoom,
    LivingOptionTags,
    LivingOptionMarkers
  },

  data () {
    return {
      mousePosition: {
        x: 0,
        y: 0,
      },
      
      mousePositionPolygonPointOffset: {
        x: 0,
        y: 0,
      },

      zoomPosition: {
        x: 0,
        y: 0,
      },
    }
  },

  methods: {
    backgroundAssetType (asset) {
      if (asset) {
        if (asset.split('.').pop() === 'mp4') {
          return 'video'
        } else {
          return 'image'
        }
      }

      return ''
    },

    updateMousePosition (e) {
      this.mousePosition.x = e.offsetX
      this.mousePosition.y = e.offsetY

      // get markers-wrapper size and position
      let markersWrapper = document.querySelector('.draggable-container')
      let markersWrapperWidth = markersWrapper.getBoundingClientRect().width
      let markersWrapperHeight = markersWrapper.getBoundingClientRect().height
      let markersWrapperX = markersWrapper.getBoundingClientRect().x
      let markersWrapperY = markersWrapper.getBoundingClientRect().y

      // get mouse screen position
      let mouseXRelative = e.clientX - markersWrapperX
      let mouseYRelative = e.clientY - markersWrapperY

      // get mouse position in percentage
      let mouseX = - mouseXRelative / markersWrapperWidth * 100
      let mouseY = - mouseYRelative / markersWrapperHeight * 100

      this.mousePosition = {
        x: mouseX,
        y: mouseY
      }

      this.zoomPosition = {
        x: mouseXRelative - markersWrapperX + 100,
        y: mouseYRelative - 100
      }
    },
  }
  
}
</script>

<style lang="scss" scoped>
.draggable-container {
  aspect-ratio: 3190 / 1960;
  overflow: hidden;
  pointer-events: all;
  position: relative;

  &__bg {
    height: 100%;
    position: relative;

    img {
      height: 100%;
      object-fit: cover;
      width: 100%;
    }
  }
}

.tag-bg {
  height: 100%;
  object-fit: cover;
  pointer-events: none;
  width: 100%;

  &.hidden {
    opacity: 0;
  }
}
</style>